import React from "react";

//export const HOST = 'http://192.169.176.97/service'
export const HOST = 'https://192.168.6.26/service'

export const GlobalContext = React.createContext({
  logged: false,
  setLogged: () => {},
  userName: '',
  setUserName: () => {},
  name: '',
  setName: () => {},
  rol: 0,
  setRol: () => {},
  token: 0,
  setToken: () => {},
  btnDisabled: false,
  setBtnDisabled: () => {},
  searchText: 'Ingresar',
  setSearchText: () => {},
  isActive: false,
  setIsActive: () => {},
  mailBody: '',
  setMailBody: () => {},
  mailTitle: '',
  setMailTitle: () => {},
  showMesage: false,
  setShowMesage: () => {},
  showWrongCredentials: false,
  setShowWrongCredentials: () => {},
  visitor: null,
  setVisitor: () => {},
  addressList: [],
  setAddressList: () => {},
  addressOptions: [],
  setAddressOptions: () => {},
  toVisitor: false,
  setToVisitor: () => {},
  globalLoading: false,
  setGlobalLoading: () => {},
  callback: null,
  setCallback: () => {},
  estadosList: [],
  setEstadosList: () => {},
  proveedoresList: [],
  setProveedoresList: () => {},
  librosProvList: [],
  setLibrosProvList: () => {},
  partidasList: [],
  setPartidasList: () => {},
  comprasList: [],
  setComprasList: () => {},
  remisionesList: [],
  setRemisionesList: () => {},
  remisionPartidasList: [],
  setRemisionPartidasList: () => {},
  librosList: [],
  setLibrosList: () => {},
  editorasList: [],
  setEditorasList: () => {},
  almacenList: [],
  setAlmacenList: () => {},
  vencimientosList: [], 
  setVencimientosList: () => {},
  vencidosList:[],
  setVencidosList: () => {},
  clientesList: [],
  setClientesList: () => {},
  ventasList: [],
  setVentasList: () => {},
  prefacturasList: [],
  setPrefacturasList: () => {},
  reportList: [],
  setReportList: () => {},

  getLogin: () => {},
  logOut: () => {},
  backHome: () => {},
  formDataToJson: () => {},
  dateForm: () => {},
  getNombreProveedor: () => {},
  getNombreLibro: () => {},
  getLibrosProv: () => {},
  getOrdenesCompra: () => {},
  getPartidas: () => {},
  getRemisiones: () => {},
  getPartidasRemision: () => {},
  getLibros: () => {},
  getEditoras: () => {},
  getProveedores: () => {},
  getNombreEditorial: () => {},
  getAlmacenes: () => {},
  getNombreAlmacen: () => {},
  getNombreEstado: () => {},
  getNombreLibroProv: () => {},
  getVencimientos: () => {},
  getISBN: () => {},
  getVencidos: () => {},
  getClientes: () => {},
  getVentas: () => {},
  getNombreCliente: () => {},
  getPrefacturas: () => {},
  getNombreOrden: () => {},
  getReport: () => {}
});